<template>
  <div class="float-menu" :style="{ minWidth: minWidth ? minWidth : 'auto' }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseFloatMenu',
  props: {
    minWidth: {
      type: String,
      default: null,
    },
  },
}
</script>

<style scoped lang="scss">
.float-menu {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  padding: var(--spacing-04, 12px) var(--spacing-07, 24px);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-05, 16px);
  border-radius: var(--spacing-09, 32px);
  border: 1px solid varFigma(neutral-90);
  background: varFigma(neutral-100-white);
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
  z-index: 200;
  max-width: 90%;
  overflow-x: auto;
}
</style>
